import { useState } from 'react';
import type { FAQContent } from '@mawkaa/types';
import { ChevronDown } from 'lucide-react';
import { cn } from '@mawkaa/ui';

interface FAQBlockProps {
  content: FAQContent;
  isEditing?: boolean;
}

export function FAQBlock({ content, isEditing }: FAQBlockProps) {
  const { title, faqs = [], style = 'accordion' } = content;
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="px-4 py-16">
      <div className="max-w-3xl mx-auto">
        {title && (
          <h2 className="text-3xl font-bold text-center mb-12">{title}</h2>
        )}

        <div className="space-y-4">
          {faqs.length > 0 ? (
            faqs.map((faq, index) => (
              <div
                key={index}
                className={cn(
                  'border rounded-lg overflow-hidden',
                  style === 'accordion' && 'bg-white'
                )}
              >
                <button
                  className="w-full px-6 py-4 flex items-center justify-between text-left"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="font-medium">{faq.question}</span>
                  <ChevronDown
                    className={cn(
                      'w-5 h-5 text-muted-foreground transition-transform',
                      openIndex === index && 'rotate-180'
                    )}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <p className="text-muted-foreground">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))
          ) : isEditing ? (
            <div className="text-center py-8 text-muted-foreground border rounded-lg">
              Ajoutez des questions dans le panneau de propriétés
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
